module.exports = __webpack_public_path__ + "static/media/searching.54606d3c.svg";